import React, { useState, useEffect } from "react";
import { Badge } from "react-bootstrap";
import * as contestService from "../../services/contestService";

const TopPlayers = (props) => {
  const [topPlayers, setTopPlayers] = useState({});
  const [topPlayersLoaded, setTopPlayersLoaded] = useState(false);
  const [showLoader, setLoader] = useState(false);
  const sortList = ["CTR", "FWD", "GRD"];
  const playerPositionAbvr = {
    "C" : "CTR",
    "F" : "FWD",
    "G" : "GRD"
  }

  useEffect(async () => {
    fetchTopPlayers(); //commented for prototyping
  }, []);

  const fetchTopPlayers = async () => {
    setLoader(true);
    await contestService.getNBATopPlayers().then((posterResponse) => {
      if (posterResponse.errorCode === 200) {
        topPlayerDataPopulate(posterResponse.data.playerData);
        setTopPlayersLoaded(true);
        setLoader(false);
      } else {
        setTopPlayers([]);
        setLoader(false);
      }
    });
  };

  const topPlayerDataPopulate = async (topPlayerData) => {
    let topPlayerDataArray = [];
    const topPlayers = topPlayerData.sort((a, b) => {
      return sortList.indexOf(a.Position) - sortList.indexOf(b.Position);
    });
    for (let k = 0; k < topPlayers.length; k++) {
      let week = topPlayers[k].nba_week;
      if (!topPlayerDataArray[week]) {
        topPlayerDataArray[week] = [];
      }
      topPlayerDataArray[week].push(topPlayers[k]);
    }

    setTopPlayers(topPlayerDataArray);
  };

  let classNames = {
    C: "quarterback",
    F: "rightback",
    G: "widereceiver",
  };

  const displayTopPlayers = (playerData) => {
    let playerDataRow = [];
    playerData.map((item, index) =>
      playerDataRow.push(
        <div className="week-list">
          {/* <h6>Week {index}</h6> */}
          <h6>Week {index}</h6>
          {/*for proto*/}
          <div className="position-wrap">
            <h5>Top Scorers by Position</h5>
            {item.map((sub_item, sub_index) => (
              <div className="player-info">
                <div className="name">
                  <Badge bg="light" className={classNames[sub_item.Position]}>
                    {playerPositionAbvr[sub_item.Position]}
                  </Badge>
                  <p>
                    {sub_item.is_team ? sub_item.TeamName : sub_item.PlayerName}
                  </p>
                </div>
                <div className="point">{sub_item.WeeklyScore}</div>
              </div>
            ))}
          </div>
        </div>
      )
    );

    return playerDataRow;
  };

  return (
    <div className="top-player-wrap">
      {showLoader && (
        <div className="playercard" style={{ textAlign: "center" }}>
          <div className="loader-wrap">
            <div className="loader"></div>
          </div>
        </div>
      )}
      {topPlayers.length ? (
        <div className="week-player-list">{displayTopPlayers(topPlayers)}</div>
      ) : (
        ""
      )}

      {!topPlayers.length && topPlayersLoaded ? (
        <div className="playercard" style={{ textAlign: "center" }}>
          <span style={{ color: "red" }}>No data to display.</span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default TopPlayers;
